export const DEFAULT_EPISODE_COVER =
  'https://source.unsplash.com/WeYamle9fDM/1600x900';
